var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"left-content"},[_c('img',{attrs:{"src":_vm.logoUrl,"alt":"Logo"}}),_c('p',[_vm._v("© "+_vm._s(_vm.copyrightText))])]),_c('a',{staticClass:"support-icon",attrs:{"href":_vm.supportEmail,"title":"Soporte"}},[_c('b-icon',{attrs:{"icon":"chat-text"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }